class ModalCTA {
  constructor(modal) {
    this.triggers = modal.querySelectorAll('.js-modal-iframe-trigger');
    this.modal = modal.querySelector('.js-modal-iframe-modal');
    this.modalClose = modal.querySelector('.js-modal-iframe-modal-close');
    this.modalIframe = modal.querySelector('.js-modal-iframe-iframe');
    this.iframeContainer = modal.querySelector('.js-modal-iframe-modal-container');
    this.tourURL = this.modal.dataset.tourUrl;
    this.tourURL = atob(this.tourURL);
    this.iframe = document.createElement('iframe');
    this.iframe.src = this.tourURL;

    if(this.triggers.length > 0) {
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          modal.classList.add('--modal-shown');
          document.body.classList.add('--modal-shown');
          this.iframeContainer.appendChild(this.iframe);
          this.modal.style.opacity = '1';
        })
      })
    }

    if(this.modalClose) {
      this.modalClose.addEventListener('click', (e) => {
        e.preventDefault();
        modal.classList.remove('--modal-shown');
        document.body.classList.remove('--modal-shown');
        this.modal.style.opacity = '0';
      })
    }
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const modalCTAs = [...document.querySelectorAll('.js-modal-iframe')];
  if(modalCTAs.length > 0) {
    modalCTAs.forEach((modalCTA) => {
      new ModalCTA(modalCTA);
    })
  }
});
